export default function hydratePsxNotificationsActionCreator(userDuck, personalization) {
  return () => async dispatch => {
    try {
      const psxNotificationsCount = await personalization.getPsxNotificationsCount();
      dispatch({
        type: userDuck.types.SET_PSX_NOTIFICATIONS_COUNT,
        payload: psxNotificationsCount
      });
      return psxNotificationsCount;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    return [];
  };
}